import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'

const ENTITY = 'tags'

export function getList (parameters = {}) {
  const params = {
    ...parameters
  }
  return new Promise((resolve, reject) => {
    new Http().get(`${ENTITY}`, { params })
      .then(response => {
        let data = {
          content: response.data.data
          // total: response.data.data.total
        }
        resolve(new ResponseWrapper(response, data))
      }).catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getAlbumsByTagId (tag_id, parameters = {}) {
  const params = {
    ...parameters
  }
  return new Promise((resolve, reject) => {
    new Http().get(`${ENTITY}/${tag_id}/albums`, { params })
      .then(response => {
        let data = {
          content: response.data.data.results,
          total: response.data.data.total
        }
        resolve(new ResponseWrapper(response, data))
      }).catch(error => reject(new ErrorWrapper(error)))
  })
}

export function getById (tag_id) {
  return new Promise((resolve, reject) => {
    return new Http().get(`${ENTITY}/${tag_id}`)
      .then(response => {
        // console.log('response', response)
        resolve(new ResponseWrapper(response, response.data.data))
      })
      .catch(error => {
        let message = error.response.data ? error.response.data.error : error.response.statusText
        reject(new ErrorWrapper(error, message))
      })
  })
}

export function getByName (tag_name) {
  return new Promise((resolve, reject) => {
    return new Http().get(`${ENTITY}/${tag_name}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => {
        let message = error.response.data ? error.response.data.error : error.response.statusText
        reject(new ErrorWrapper(error, message))
      })
  })
}

export function create (data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).post(`${ENTITY}`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function update (id, data) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).patch(`${ENTITY}/${id}`, data)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function remove (id) {
  return new Promise((resolve, reject) => {
    new Http({auth: true}).delete(`${ENTITY}/${id}`)
      .then(response => resolve(new ResponseWrapper(response, response.data.data)))
      .catch(error => reject(new ErrorWrapper(error)))
  })
}

export function find (parameters = {}) {
  const params = {
    ...parameters
  }
  return new Promise((resolve, reject) => {
    new Http().get(`${ENTITY}/find`, {params})
      .then(response => {
        let data = {
          content: response.data.data
          // total: response.data.data.total
        }
        resolve(new ResponseWrapper(response, data))
      }).catch(error => reject(new ErrorWrapper(error)))
  })
}



// WEBPACK FOOTER //
// ./src/services/tags.service.js